'use strict';

var _classCallCheck = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var EvaluationResult = /*#__PURE__*/function () {
  function EvaluationResult(value) {
    var missing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    _classCallCheck(this, EvaluationResult);
    this.value = value;
    this.missing = missing;
    this.errors = errors;
  }
  _createClass(EvaluationResult, [{
    key: "valueOf",
    value: function valueOf() {
      return typeof this.value === 'object' && this.value !== null ? this.value.valueOf() : this.value;
    }
  }, {
    key: "toString",
    value: function toString() {
      return typeof this.value === 'string' ? this.value : isDef(this.value) ? this.value.toString() : '(missing)';
    }
  }]);
  return EvaluationResult;
}();
module.exports = EvaluationResult;
var isDef = function isDef(val) {
  return val !== null && typeof val !== 'undefined';
};